export const contentTypeSlugToName = {
    'ps-sacred-art': 'Sacred Art',
    'ps-recipe': 'Recipe',
    'ps-sacred-music': 'Music',
    'ps-family-activity': 'Family',
    'ps-prose-poetry': 'Prose',
    'ps-history': 'History',
    'ps-national-customs': 'National',
  };

  export const contentTypeImages = {
    'Sacred Art': '/media/images/Art.png',
    'Prose': '/media/images/Prose.png',
    'National': '/media/images/National.png',
    'History': '/media/images/History.png',
    'Music': '/media/images/Music.png',
    'Family': '/media/images/Family.png',
    'Recipe': '/media/images/Recipe.png',
  };
  